import { render, staticRenderFns } from "./rules.component.vue?vue&type=template&id=524671ba&scoped=true"
import script from "./rules.component.vue?vue&type=script&lang=js"
export * from "./rules.component.vue?vue&type=script&lang=js"
import style0 from "./rules.component.vue?vue&type=style&index=0&id=524671ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524671ba",
  null
  
)

export default component.exports